import "core-js/modules/es.array.concat";
import React from 'react';
import PropTypes from 'prop-types';
import Block from '../../../block/Block';
import CmsContent from '../../CmsContent';
import { getClasses } from '../../../../lib/style-utils/style-utils';
import useDevice from '../../../hooks/use-device';
import TitleAndCta from './TitleAndCta';
import styles from './JumpCta.less';

var JumpCta = function JumpCta(_ref) {
  var data = _ref.data;
  var device = useDevice();

  var _ref2 = data || {},
      _ref2$component = _ref2.component;

  _ref2$component = _ref2$component === void 0 ? {} : _ref2$component;
  var metadata = _ref2$component.metadata,
      _ref2$component$conte = _ref2$component.content;
  _ref2$component$conte = _ref2$component$conte === void 0 ? {} : _ref2$component$conte;
  var title = _ref2$component$conte.title,
      cta = _ref2$component$conte.cta,
      text = _ref2$component$conte.text,
      phoneNumber = _ref2$component$conte.phone_number,
      _ref2$componentTempla = _ref2.componentTemplate;
  _ref2$componentTempla = _ref2$componentTempla === void 0 ? {} : _ref2$componentTempla;
  var template = _ref2$componentTempla.title;

  var _ref3 = metadata || {},
      _ref3$buttoncolor = _ref3.buttoncolor;

  _ref3$buttoncolor = _ref3$buttoncolor === void 0 ? {} : _ref3$buttoncolor;
  var buttoncolor = _ref3$buttoncolor.Key,
      buttoncoloralt = _ref3$buttoncolor.key;
  var showSecondary = !device.isMobile() && template !== 'Secondary_CTA_Enhanced';
  var ctaStyles = !showSecondary ? styles['cta-button'] : styles['cta-button-desktop'];
  var borderStyles = !showSecondary ? styles['border-top'] : styles['border-left'];
  return /*#__PURE__*/React.createElement(Block, {
    className: styles['jump-cta-wrapper'],
    "data-en": 'cms-jump-cta'
  }, (text || phoneNumber) && title && cta ? /*#__PURE__*/React.createElement(Block, {
    layout: true,
    vertical: !showSecondary,
    center: true,
    className: styles['cta-border']
  }, /*#__PURE__*/React.createElement(Block, {
    p: "s",
    layout: true,
    vertical: !showSecondary,
    center: true
  }, title && /*#__PURE__*/React.createElement("div", {
    className: getClasses({
      styles: styles,
      classes: ['cta-title'],
      device: device
    })
  }, /*#__PURE__*/React.createElement(CmsContent, {
    "data-en": 'cms-jump-cta-title',
    content: title
  })), cta && /*#__PURE__*/React.createElement("div", {
    className: "".concat(ctaStyles, " ").concat(styles[buttoncolor || buttoncoloralt], " ").concat(buttoncolor || buttoncoloralt)
  }, /*#__PURE__*/React.createElement(CmsContent, {
    "data-en": 'cms-jump-cta-cta',
    content: cta
  }))), /*#__PURE__*/React.createElement(Block, {
    layout: true,
    vertical: true,
    center: true,
    className: borderStyles
  }, /*#__PURE__*/React.createElement(Block, {
    p: "s"
  }, text && /*#__PURE__*/React.createElement("p", {
    className: styles['cta-text']
  }, /*#__PURE__*/React.createElement(CmsContent, {
    content: text
  })), phoneNumber && /*#__PURE__*/React.createElement("p", {
    className: styles['cta-text']
  }, /*#__PURE__*/React.createElement(CmsContent, {
    content: phoneNumber
  }))))) : /*#__PURE__*/React.createElement(TitleAndCta, {
    title: title,
    cta: cta,
    device: device,
    buttoncolor: buttoncolor || buttoncoloralt
  }));
};

JumpCta.propTypes = {
  data: PropTypes.object.isRequired
};
export default JumpCta;